module.exports = __webpack_public_path__ + "img/dunhua-1.1269ac94.jpg";